import { graphql } from '@/gql/generated'

export const UpdateShowcaseItemsDocument = graphql(`
  mutation UpdateShowcaseItems($showcaseId: uuid!, $showcaseItems: [showcase_items_insert_input!]!) {
    # First delete all existing showcase items for this showcase
    delete_showcase_items(where: { showcase_id: { _eq: $showcaseId } }) {
      affected_rows
    }

    # Then insert new showcase items in the correct order
    insert_showcase_items(objects: $showcaseItems) {
      affected_rows
      returning {
        id
        showcase_id
        token_id
        display_order
        created_at
        updated_at
      }
    }
  }
`)
